import React, { useMemo } from 'react'
import type { Instrument } from '@nutrimatic/sdk'

import DoubleCurrencyLogo from '@/components/DoubleLogo'
import { getActiveChainId } from '@/config/active'
import { cn } from '@/lib/utils'

import { instrumentToCurrency } from './instrumentCurrency'

/** Par de logos (mismo patrón que Swap) a partir de instrumentos Nutrimatic. */
export function PairInstrumentLogos({
  base,
  quote,
  size = 24,
  layout = 'stacked',
  className,
}: {
  base?: Instrument | null
  quote?: Instrument | null
  size?: number
  layout?: 'stacked' | 'separated'
  className?: string
}) {
  const chainId = getActiveChainId()
  const currency0 = useMemo(() => instrumentToCurrency(base, chainId), [base, chainId])
  const currency1 = useMemo(() => instrumentToCurrency(quote, chainId), [quote, chainId])

  if (!currency0 && !currency1) return null

  return (
    <span className={cn('inline-flex shrink-0', className)}>
      <DoubleCurrencyLogo
        currency0={currency0}
        currency1={currency1}
        size={size}
        layout={layout}
      />
    </span>
  )
}
